/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Ludovic's Portfolio (Ludovic KUN)",
  description:
    "A passionate individual who is always curious about cutting-edge technology and solving real worlds problem using Artificial Intelligence.",
  og: {
    title: "Ludovic's Portfolio (Ludovic KUN)",
    type: "website",
    url: "https://shiro-lk.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Ludovic K",
  logo_name: "LudovicKun",
  //nickname: "layman_brother",
  subTitle:
    "A passionate individual who is always curious about cutting-edge technology and solving real worlds problem using Artificial Intelligence.",
  resumeLink:
    "link",
  portfolio_repository: "https://github.com/Shiro-LK",
  githubProfile: "https://github.com/Shiro-LK",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/Shiro-LK",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/ludovic-kun-245b8a128/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  /*{
    name: "YouTube",
    link: "https://youtube.com/c/DevSense19",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },*/
  {
    name: "Gmail",
    link: "mailto:gadgetai.23@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
 /* {
    name: "X-Twitter",
    link: "https://twitter.com/ashutosh_1919",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/laymanbrother.19/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/layman_brother/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },*/
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various A.I and deep learning use cases",
        "⚡ Experience of working with Computer Vision, Audio Processing and NLP projects",
        "⚡ Experience in various industries such as healthcare, social media, legal, manufacture, etc",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
		{
          skillName: "Google Cloud Platform",
          imageSrc: "gcp.png",
        },
		{
          skillName: "Docker",
          imageSrc: "docker.png",
        },
		{
          skillName: "Onnx",
          imageSrc: "onnx.png",
        },
    
    {
          skillName: "sklearn",
          imageSrc: "scikitlearn.svg",
        },
		{
          skillName: "OpenCV",
          imageSrc: "opencv.svg",
        },
		// add onnx/docker
      ],
    },
   /* {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React-Redux",
        "⚡ Developing mobile applications using Flutter, React Native and solo android apps using Kotlin",
        "⚡ Creating application backend in Node, Express & Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Gatsby",
          fontAwesomeClassname: "simple-icons:gatsby",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on cloud to use on mobile devices",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Inkscape",
          fontAwesomeClassname: "simple-icons:inkscape",
          style: {
            color: "#000000",
          },
        },
      ],
    },*/
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    /*{
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/layman_brother/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/ashutosh_1919",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@ashutosh391",
    },*/
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/ludovick",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Université Paris Saclay, France",
      subtitle: "MSc in Computer Science - AI",
      logo_path: "Universite-Paris-Saclay.png",
      alt_name: "Master AI",
      duration: "2017 - 2018",
      descriptions: [
        "⚡ I have taken variety of courses related to Artificial inteliggnce such as Machine learning, deep learning, speech recognition, NLP, computer vision.",
        "⚡ Apart from this, I have done a 6-month internship in the field of computer vision to detect defects on lenses.",
      ],
      website_link: "https://www.universite-paris-saclay.fr",
    },
	{
      title: "Sorbonne Université",
      subtitle: "Double Degree: MSc in Robotics",
      logo_path: "Logo_Sorbonne_Université.png",
      alt_name: "Master Sorbonne Université",
      duration: "2016 - 2017",
      descriptions: [
        "⚡  My knowledge of Robotics and virtual reality have been enriched by various courses, such as computer vision, mechanics, and haptics interfaces.",
      ],
      website_link: "https://sciences.sorbonne-universite.fr/masters/master-automatique-robotique/parcours-systemes-avances-et-robotiques-sar",
    },
	
    {
      title: "Polytech Sorbonne (Engineering school from Sorbonne Université)",
      subtitle: "Engineering Degree in Robotics",
      logo_path: "polytech_sorbonne.png",
      alt_name: "Engineering Polytech Sorbonne",
      duration: "2012 - 2017",
      descriptions: [
        "⚡ My education in Robotics has exposed me to a wide range of topics, including computer science, mobile robotics, pattern recognition, signal processing, control theory, electronics, and more." ,
        "⚡ I have also gained practical experience in Computer Vision through an internship that involved image processing and deep neural network techniques.",
      ],
      website_link: "https://www.polytech.sorbonne-universite.fr/formations/robotique",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "SQL for Data Science",
      subtitle: "- Sadie St. Lawrence",
      logo_path: "ucdavis.avif",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/RWCY6DCCZ8CB",
      alt_name: "University California Davis",
      color_code: "#8C151599",
    },
    {
      title: "Generative Adversarial Networks (GANs)",
      subtitle: "- Sharon Zhou",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/UL5GJT2G5GDX",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
	  {
      title: "Distributed Computing with Spark SQL",
      subtitle: "- Brooke Wening, Conor Murphy",
      logo_path: "ucdavis.avif",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/QVKH2VXX3SS5",
      alt_name: "University California Davis",
      color_code: "#8C151599",
    },
	
    {
      title: "Machine Learning Operations (MLOps)",
      subtitle: "- Google Cloud Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/3TUUWDN688AH",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
   /* {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },*/
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Competitions",
  description:
    "I have worked with many evolving startups as ML and DL Developer, and Data Scientist. I have also worked with some well established companies mostly as AI Developer."
  ,
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Senior Data Scientist",
          company: "Freelance/Consultant",
          company_url: "",
          logo_path:  "NoLogo.png",
          duration: "2023 -",
          location: "Remote",
          description:
            ["As a Senior Data Scientist and Consultant, I interacted with clients to understand their business needs and provide them with tailored A.I solutions. ", 
            "Example: Designed a whisper-based speech-to-text solution for video with a 30-second delay. ",
          ],
            color: "#0879bf",
        },
        {
          title: "Senior Data Scientist - Consultant Customer Facing ",
          company: "Abacus",
          company_url: "abacus.ai",
          logo_path: "abacusai_logo.png",
          duration: "2023 - ",
          location: "Remote",
          description:
            ["As a Senior Data Scientist and Consultant, I interacted with clients to understand their business needs and provide them with tailored A.I solutions: ",
              "\n⚡ NLP Discriminative Solutions: Developed NLP solutions, including named entity recognition, document classification, using transformers architectures. ",
            "\n⚡ Large Language Models: Utilized Foundation Models for various use cases such as document generation, Question Answering (using RAG), and terms extraction etc. "],
          color: "#0879bf",
        },
        {
          title: "Machine Learning/Deep Learning Engineer",
          company: "Logically",
          company_url: "https://www.linkedin.com/company/muffito-inc/about/",
          logo_path: "logically.png",
          duration: "2021 - 2023",
          location: "Leeds, UK",
          description: 
          ["As a Deep Learning engineer, I interacted with stakeholders to designed machine learning solutions to detect misinformation and threats: ", 
          "\n⚡ Developed solutions for acquiring signals from various data sources, including OCR and transcription for English and multilingual content. ", 
          "\n⚡ Developed end-to-end solutions, from dataset creation to training, benchmarking, and monitoring using MLFlow. ",
          "\n⚡ Implemented simple deployment using REST APIs (Flask, FastAPI) and Gradio for stakeholder demos.",
            "\n⚡ Developed solutions for object detection (weapons), landmark recognition (geolocation), and emotion recognition using PyTorch and TensorFlow."],
          color: "#9b1578",
        },
        {
          title: "A.I Engineer",
          company: "Crisp Thinking",
          company_url: "https://www.linkedin.com/company/freecopy/about/",
          logo_path: "crisp.png",
          duration: "2019-2021",
          location: "Leeds, UK",
          description:
            ["As a A.I engineer, I interacted with stakeholders to designed end to end solutions to detect risks on social media platforms: ", 
            "\n⚡ Developed and deployed deep learning solutions for risk detection on social media platforms.", 
            "\n⚡ Pretrained and fine-tuned models (CNN, BERT, Electra, RoBerta) for text and video data (sentiment analysis, video classification, risk classification). ",
            "\n⚡ Served models using TorchServe and deployed them on Google Cloud Platform (GCP) using Docker and Google AI Platform. ", 
            "\n⚡ Pushed the limits of deep learning models through strategies like Knowledge Distillation and Ensembling for smaller yet high-performance models."],
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Engineer, Data Science Intern",
          company: "Microsoft Development (MSD)",
          company_url: "https://www.microsoft.com/ja-jp/mscorp/mid-career/",
          logo_path: "microsoft.png",
          duration: "3 months, 2018",
          location: "Tokyo, Japan",
          description:
            ["⚡ Improved user experience by analyzing Input Session Telemetry data and creating rule-based detection algorithms for Windows. ",
            "\n⚡ Managed large datasets using Scope/SQL and conducted queries. ",
            "\n⚡ Detected and analyzed anomalies in input keyboard telemetry data using Jupyter Notebook, Python, and Pandas."],
          color: "#000000",
        },
        {
          title: "Deep Learning Engineer, Computer Vision Intern",
          company: "Essilor Luxoticca",
          company_url: "https://www.essilorluxottica.com/en/",
          logo_path: "essilorluxoticca.png",
          duration: "6 months, 2018",
          location: "Créteil, France",
          description:
            ["As an intern, I created a PoC which can detect and recognise cosmetic defects on the lens using a Deep Learning solution.",
            "The differents tasks realised were:",
            "\n⚡ State of the art (SOTA) on object detection algorithms in Deep Learning",
            "\n⚡ Development and implementation of the solution using DL with Keras/TF, benchmark the results. ", 
            "\n⚡ Create GUI in C\# to make a demonstration of the model in a real-world environment. "
            ],
          color: "#ee3c26",
        },
        {
          title: "Deep Learning Engineer, Computer Vision Intern",
          company: "WASSA",
          company_url:
            "https://wassa.io/en/",
          logo_path: "wassa.png",
          duration: "6 months, 2017",
          location: "Boulogne-Billancourt, France",
          description:
           ["As an intern, I create a solution which estimates the age and gender from a face image, use for their internal mobile app and a demographic estimation solution. ",
           "The different tasks realised were:",
           "\n⚡ State of the Arts on the recognition of morphological criteria and image classification (CNN, VGG, ResNet, Inception). ",
           "\n⚡ Labelisation of the training and test dataset, in order to reduce some bias. ", 
           "\n⚡ Experimentations of different solutions using the MXNet framework on python and benchmarking."
           ],
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Competitions",
      experiences: [
        {
          title: "Movie Genre Prediction",
          company: "rank: 1st",
          company_url: "https://huggingface.co/spaces/competitions/movie-genre-prediction",
          logo_path: "hf2.png",
          duration: "2023",
          location: "Huggingface",
          description:
            "The goal of this competition is to design a predictive model that accurately classifies movies into their respective genres based on their titles and synopses. The dataset contains a mix of both original and AI-generated titles, genres, and synopses to test the robustness of the models. The 10 genres include action, adventure, crime, family, fantasy, horror, mystery, romance, scifi, and thriller.",
          color: "#000000",
        },

        {
          title: "PetFinder.my - Pawpularity Contest",
          company: "rank: 3st",
          company_url: "https://www.kaggle.com/competitions/petfinder-pawpularity-score",
          logo_path: "kaggle.png",
          duration: "2022",
          location: "Kaggle",
          description:
            "The task is to predict engagement with a pet's profile based on the photograph for that profile. You are also provided with hand-labelled metadata for each photo. The dataset for this competition therefore comprises both images and tabular data.",
          color: "#4285F4",
        },
        {
          title: "BirdCLEF 2021 - Birdcall Identification",
          company: "rank: 3st",
          company_url: "https://www.kaggle.com/competitions/birdclef-2021",
          logo_path: "kaggle.png",
          duration: "2021",
          location: "Kaggle",
          description:
            "The goal is to identify which birds are calling in long recordings, given training data generated in meaningfully different contexts. This is the exact problem facing scientists trying to automate the remote monitoring of bird populations.",
          color: "#D83B01",
        },
        
        
        {
          title: "AI4D Malawi News Classification Challenge",
          company: "rank: 3st",
          company_url: "https://zindi.africa/competitions/ai4d-malawi-news-classification-challenge",
          logo_path: "Zindi_Logo.png",
          duration: "2021",
          location: "Zindi",
          description:
            "The task is to classify the news articles into one of 19 classes. The articles presented in the dataset are full articles and span many different genres: from social issues, family and relationships to political or economic issues.",
          color: "#181717",
        },

        {
          title: "Cassava Leaf Disease Classification",
          company: "rank: 11th",
          company_url:
            "https://www.kaggle.com/competitions/cassava-leaf-disease-classification",
          logo_path: "kaggle.png",
          duration: "2021",
          location: "Kaggle",
          description:
            "The goal was to distinguish between several diseases that cause material harm to the food supply of many African countries. In some cases the main remedy is to burn the infected plants to prevent further spread, which can make a rapid automated turnaround quite useful to the farmers.",
          color: "#0C9D58",
        },
        {
          title: "RANZCR CLiP - Catheter and Line Position Challenge",
          company: "rank: 10th",
          company_url:
            "https://www.kaggle.com/competitions/ranzcr-clip-catheter-line-classification",
          logo_path: "kaggle.png",
          duration: "2021",
          location: "Kaggle",
          description:
            "The goal was to detect the presence and position of catheters and lines on chest x-rays. The model should be able to tell if a tube is poorly placed.",
          color: "#0C9D58",
        },

        {
          title: "GIZ NLP Agricultural Keyword Spotter",
          company: "rank: 1st",
          company_url: "https://zindi.africa/competitions/giz-nlp-agricultural-keyword-spotter",
          logo_path: "Zindi_Logo.png",
          duration: "2020",
          location: "Zindi",
          description:
            "The goal was to build a machine learning model to identify the agricultural keyword (which may be in English or Luganda) spoken in an audio clip. The keywords relate to crops, diseases, fertilizers, herbicides or other general agricultural topics.",
          color: "#181717",
        },

      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them using cloud infrastructure/API.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "",
    //"I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "2022.constraint-1.4",
      name: "Logically at the Constraint 2022: Multimodal role labelling",
      createdAt: "2022-05",
      description: "Paper Written on ACL (Association for Computational Linguistics) workshop 2022",
      url:
        "https://aclanthology.org/2022.constraint-1.4.pdf",
    },
    
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "contact-modified.png",
    description:
      "You can message me, I will reply within 24 hours. I can help you with ML, AI, Data Science Development.",
  },
  /*blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },*/
  /*addressSection: {
    title: "Address",
    subtitle:
      "Ambavadi vas, Kanodar, T.A.-Palanpur, Dist.-Banaskantha, Gujarat - 385520",
    locality: "Kanodar",
    country: "IN",
    region: "Gujarat",
    postalCode: "385520",
    streetAddress: "Ambavadi vas",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76",
  },*/
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
